
import '../css/routingStyle/contactpage.css'
import Navbar from '../Navbar';
import { useState } from 'react';


export default function ContactPage () {
  const [myMode,setMymode] =useState("light");
    return (
<>
<Navbar className="nav-cont" setMymode={setMymode}/>

<section className="contact-page">


<div className="container">
            
            
            <div className="contact-form">
<h3>Let’s Work Together.</h3>
<form action="post">
    <input type="text" placeholder="Name*" name="name" className="input-field" required/>
    <input type="email" placeholder="Email*" name="email" className="input-field" required/>
    <input type="text" placeholder="Subject*" name="subject" className="input-field" required/>
    <textarea name="msg" placeholder="Message*" required></textarea>
    <button type="submit">Send Message</button>
</form>
</div>


<div className="info">
<h2>Contact info</h2>
<article>
<ul className="info-list">
<li className="info-item">
<div className="info-content">
<p>mail us</p>
<a href="mailto:techno.media2697@gmail.com">techno.media2697@gmail.com</a>
</div>
</li>
<li className="info-item">
<div className="info-content">
<p>Contact US</p>
<a href="tel:+201202412997">+201202412997</a>
<a href="tel:+201127570256">+201127570256</a>
</div>
</li>
<li className="info-item">
<div className="info-content">
<p>Adress</p>
<a href="#">El Minya , Egypt</a>
</div>
</li>
</ul>
</article>
</div>

</div>
</section>
</>

)
}